module.exports = __webpack_public_path__ + "images/speed-two-default.36da6987cb24f7b825c21cb466152be2.png";